module.exports = __webpack_public_path__ + "img/loading-cctv.3dc88fd5.jpg";